module.exports = __webpack_public_path__ + "h5/img/duihao.f2fcaeda.png";